// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.service-summary-wrapper {
  padding: var(--spacing-small);
  border-radius: var(--border-radius-secondary) !important;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);
  min-width: 380px;
  cursor: auto;
}
.service-summary-wrapper .vert-col {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.service-summary-wrapper .vert-row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.service-summary-wrapper .service-summary-content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-small);
}
.service-summary-wrapper .service-summary-content .row-description .vert-paragraph {
  width: 50%;
}
.service-summary-wrapper .service-summary-content .row-description .strong {
  font-weight: 600;
}
.service-summary-wrapper .service-summary-content .row-termsOfUse .vert-paragraph {
  margin-left: 10px;
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 20px;
}
.service-summary-wrapper .service-summary-content .row-termsOfUse a {
  color: #009dff;
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
}
.service-summary-wrapper .service-summary-content .vert-paragraph {
  font-size: var(--font-paragraph);
  font-weight: 400;
  line-height: 20px;
  cursor: auto;
}
.service-summary-wrapper .service-summary-content .vert-paragraph.link {
  text-decoration: underline;
  cursor: pointer;
}
.service-summary-wrapper .service-summary-content .service-summary-button .vert-button {
  background-color: var(--color-highlight) !important;
  font-weight: 400;
  width: 100%;
  transition: all 0.2s ease-in-out;
}
.service-summary-wrapper .service-summary-content .service-summary-button .vert-button:hover {
  opacity: 0.8;
  border-color: var(--color-highlight) !important;
}
.service-summary-wrapper .service-summary-content .service-summary-button .vert-button.disabled-button {
  background-color: var(--color-neutral-light) !important;
  cursor: not-allowed;
}
.service-summary-wrapper .service-summary-content .service-summary-button .vert-button.disabled-button:hover {
  border-color: var(--color-neutral-light) !important;
}
.service-summary-wrapper .divider {
  height: 1px;
  background-color: #eaeaea;
}
@media screen and (max-width: 768px) {
  .service-summary-wrapper {
    min-width: unset !important;
  }
  .service-summary-wrapper .service-summary-content .row-description {
    display: flex;
    justify-content: space-between;
  }
  .service-summary-wrapper .service-summary-content .row-description .vert-paragraph {
    width: unset !important;
  }
}
.payment-summary-button {
  width: 100%;
}
.payment-summary-disclaimer {
  font-weight: 400 !important;
  font-size: var(--font-small);
  margin-top: 2%;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/services/SummaryStyles.less"],"names":[],"mappings":"AACA;EACE,6BAAA;EACA,wDAAA;EACA,gDAAA;EACA,gBAAA;EACA,YAAA;AAAF;AALA;EAQI,2BAAA;EACA,0BAAA;AAAJ;AATA;EAaI,0BAAA;EACA,yBAAA;AADJ;AAbA;EAkBI,aAAA;EACA,sBAAA;EACA,yBAAA;AAFJ;AAlBA;EAwBQ,UAAA;AAHR;AArBA;EA4BQ,gBAAA;AAJR;AAxBA;EAkCQ,iBAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;AAPR;AA9BA;EAyCQ,cAAA;EACA,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;AARR;AArCA;EAkDM,gCAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;AAVN;AAYM;EACE,0BAAA;EACA,eAAA;AAVR;AA/CA;EA+DQ,mDAAA;EACA,gBAAA;EACA,WAAA;EACA,gCAAA;AAbR;AAeQ;EACE,YAAA;EACA,+CAAA;AAbV;AAgBQ;EACE,uDAAA;EACA,mBAAA;AAdV;AAeU;EACE,mDAAA;AAbZ;AAhEA;EAqFI,WAAA;EACA,yBAAA;AAlBJ;AAsBA;EACE;IACE,2BAAA;EApBF;EAmBA;IAKM,aAAA;IACA,8BAAA;EArBN;EAeA;IASQ,uBAAA;EArBR;AACF;AA2BA;EACE,WAAA;AAzBF;AA4BA;EACE,2BAAA;EACA,4BAAA;EACA,cAAA;AA1BF","sourcesContent":["// DESKTOP\n.service-summary-wrapper {\n  padding: var(--spacing-small);\n  border-radius: var(--border-radius-secondary) !important;\n  box-shadow: 0px 2px 8px 0px rgba(0, 0, 20, 0.12);\n  min-width: 380px;\n  cursor: auto;\n\n  .vert-col {\n    padding-right: 0 !important;\n    padding-left: 0 !important;\n  }\n\n  .vert-row {\n    margin-right: 0 !important;\n    margin-left: 0 !important;\n  }\n\n  .service-summary-content {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-small);\n\n    .row-description {\n      .vert-paragraph {\n        width: 50%;\n      }\n\n      .strong {\n        font-weight: 600;\n      }\n    }\n\n    .row-termsOfUse {\n      .vert-paragraph {\n        margin-left: 10px;\n        font-size: var(--font-paragraph);\n        font-weight: 400;\n        line-height: 20px;\n      }\n\n      a {\n        color: #009dff;\n        font-size: var(--font-paragraph);\n        font-weight: 400;\n        line-height: 20px;\n        text-decoration-line: underline;\n      }\n    }\n\n    .vert-paragraph {\n      font-size: var(--font-paragraph);\n      font-weight: 400;\n      line-height: 20px;\n      cursor: auto;\n\n      &.link {\n        text-decoration: underline;\n        cursor: pointer;\n      }\n    }\n\n    .service-summary-button {\n      .vert-button {\n        background-color: var(--color-highlight) !important;\n        font-weight: 400;\n        width: 100%;\n        transition: all 0.2s ease-in-out;\n\n        &:hover {\n          opacity: 0.8;\n          border-color: var(--color-highlight) !important;\n        }\n\n        &.disabled-button {\n          background-color: var(--color-neutral-light) !important;\n          cursor: not-allowed;\n          &:hover {\n            border-color: var(--color-neutral-light) !important;\n          }\n        }\n      }\n    }\n  }\n\n  .divider {\n    height: 1px;\n    background-color: #eaeaea;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .service-summary-wrapper {\n    min-width: unset !important;\n\n    .service-summary-content {\n      .row-description {\n        display: flex;\n        justify-content: space-between;\n\n        .vert-paragraph {\n          width: unset !important;\n        }\n      }\n    }\n  }\n}\n\n.payment-summary-button {\n  width: 100%;\n}\n\n.payment-summary-disclaimer {\n  font-weight: 400 !important;\n  font-size: var(--font-small);\n  margin-top: 2%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
